export default "__VITE_ASSET__C8TUTpKG__"